import _ from 'underscore'

export default {
  toggleActive: (state, value) => {
    state.active = (_.isBoolean(value.active)) ? value.active : !state.active
    state.emailaddress = (_.isString(value.emailaddress)) ? value.emailaddress : ''
  }
}
